import * as React from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/utils/cn";

type SectionCardProps = {
  title?: string;
  subtitle?: string;
  category?: string;
  headerExtra?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
};

export function SectionCard({
  title,
  subtitle,
  category,
  headerExtra,
  actions,
  children,
  className,
  bodyClassName,
}: SectionCardProps) {
  const hasHeader = Boolean(title || category || headerExtra || actions);
  return (
    <Card className={cn("flex h-full flex-col", className)}>
      {hasHeader && (
        <div className="flex flex-wrap items-center justify-between gap-2 px-5 pt-5">
          <div className="flex flex-wrap items-center gap-3">
            {category && (
              <Badge variant="default" className="capitalize">
                {category}
              </Badge>
            )}
            {title && (
              <h3 className="text-sm font-normal text-muted-foreground">
                {title}
              </h3>
            )}
            {subtitle && (
              <span className="text-xs text-muted-foreground">{subtitle}</span>
            )}
            {headerExtra}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className={cn("flex flex-1 flex-col px-5 py-4", bodyClassName)}>
        {children}
      </div>
    </Card>
  );
}
